export default "__VITE_ASSET__CP2ty090__"